exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-bg[data-v-70665e11]{background-color:var(--cockpitTabsActiveColor)!important;line-height:28px!important}", ""]);

// exports
